import clsx from "clsx";

import { DutyStatus } from "@web-app/types";

interface DutyStatusIconProps {
  className?: string;
  status: DutyStatus;
}

const DutyStatusIcon = ({ status, className }: DutyStatusIconProps) => {
  return (
    <span
      className={clsx(
        "block rounded-full ring-1 ring-white",
        status === "ONLINE"
          ? " bg-green-500"
          : status === "OFFLINE"
            ? "bg-gray-500"
            : status === "INTRANSIT"
              ? "bg-blue-500 "
              : "",
        className,
      )}
    />
  );
};

export default DutyStatusIcon;
